export class CiraHelpKeyConstants {
    // Community Module
    static readonly communityBoardOfDirector = 'RP_BOARD_OF_DIRECTORS';
    static readonly communityReportViolation = 'RP_REPORT_VIOLATION';
    static readonly communityDashboard = 'RP_COMMUNITY_DASHBOARD';
    static readonly communityInformation = 'RP_COMMUNITY_INFO';
    static readonly communityLegalInformation = 'RP_LEGAL_INFO';
    static readonly communityCalendar = 'RP_COMMUNITY_CALENDAR';
    static readonly communityResidentDirectory = 'RP_RESIDENT_DIRECTORY';
    static readonly communityRestrictionSummary = 'FULLRESTRICTIONTEXT.ASPX';
    static readonly communityProperties = 'MP_COMMUNITY_PROPERTIES';
    static readonly communityMap = 'MP_COMMUNITY_MAP';
    static readonly communityDelinquencyDetail = 'DELINQUENCYDETAIL.ASPX';

    // Property Module
    static readonly propertyRestrictionSummary = 'RP_VIOLATION_DEFINITIONS';
    static readonly propertyAccountsPayment = 'RP_PAYMENT_HISTORY';
    static readonly propertyAccountStatement = 'RP_STATEMENT';
    static readonly propertyAccessMediaList = 'RP_ACCESS_MEDIA_LIST';
    static readonly propertyRecurringPayment = 'RP_ACH_CONFIGURATION';
    static readonly propertyOneTimePayment = 'RP_MAKE_ONETIME_PAYMENT';
    static readonly propertyDocuments = 'RP_DOCUMENTS';
    static readonly propertyAdditionalInfo = 'RP_ADDITIONAL_INFO';
    static readonly propertyInformation = 'RP_PROPERTY_INFO';
    static readonly propertyOwnerInformation = 'RP_OWNER_INFO';
    static readonly propertyContactInformation = 'RP_CONTACT_INFO';
    static readonly propertyDirectorySharing = 'RP_DIRECTORY_SHARING';
    static readonly propertyAccountInfoContacts = 'RP_ACCOUNT_INFO_CONTACTS';
    static readonly propertyArchitechturalApplication = 'RP_ACC';
    static readonly propertyCompliance = 'RP_COMPLIANCE';
    static readonly propertyDashboard = 'RP_DEFAULT';
    static readonly propertyNotes = 'MP_PROPERTY_NOTES';
    static readonly propertyCommunication = 'MP_COMMUNICATIONS';
    static readonly propertyCollection = 'MP_PROPERTY_COLLECTION';
    static readonly propertyStatuses = 'MP_PROPERTY_STATUSES';

    // Home & Search
    static readonly applicationHome = 'MP_HOME';
    static readonly communityHome = 'MP_COMMUNITY_HOME';
    static readonly ownerHome = 'MP_OWNER_HOME';
    static readonly advancedSearch = 'MP_ADVANCED_SEARCH';
    static readonly ciramailHome = 'MP_CIRAMAIL';
    static readonly portalAlerts = 'MP_ALERTS';
    static readonly logReturnedMail = 'MP_LOG_RETURNED_MAIL';
    static readonly userDashboardWidget = 'MYDASHBOARD.ASPX';

    // AAP Workflow Module
    static readonly aapWfQueue = 'MP_AAPWF_QUEUE';
    static readonly aapWfProcess = 'MP_AAPWF_PROCESS';
    static readonly aapWfMetrics = 'MP_AAPWF_METRICS';

    // Reports Module
    static readonly reports = 'MP_REPORTS';
    static readonly reportsMoveIns = 'MOVEINSUMMARY.ASPX';
    static readonly reportsSummary = 'OPERATIONSSUMMARY.ASPX';

    // Cirabooks Module
    static readonly cbHome = 'MP_CB_HOME';
    // Cash Management
    static readonly cbCMCashReceipts = 'CIRABOOK_CASHRECEIPTS.ASPX';
    static readonly cbCMDeposits = 'CIRABOOK_DEPOSITS.ASPX';
    static readonly cbCMBatches = 'CIRABOOK_BATCH.ASPX';
    static readonly cbCMManageBankStatement = 'helproot';
    static readonly cbCMBankAccounts = 'CIRABOOKSBANKACCOUNTSREPORT.ASPX';
    static readonly cbCMLockboxPaymentFile = 'LOCKBOXPAYMENTFILE.ASPX';
    static readonly cbCMBankReconciliation = 'CIRABOOKSBANKRECONCILE.ASPX';
    static readonly cbCMUnmatchedTransactions = 'UNMATCHEDTRANSACTIONS.ASPX';
    static readonly cbCMFundsTransfer = 'CIRABOOKS_BANKACCOUNTFUNDTRANSFER.ASPX';
    static readonly cbCMCreateCashReciept = 'CIRABOOKS_CREATECASHRECEIPTSINBATCH.ASPX';
    // Accounts Receivable
    static readonly cbARLedger = 'MP_CB_AR_LEDGER';
    static readonly cbARBatches = 'MP_CB_AR_BATCHES';
    static readonly cbARCustomerAging = 'MP_CB_AR_CUSTOMER_AGING';
    static readonly cbARInvoiceAnalysis = 'MP_CB_AR_INVOICE_ANALYSIS';
    static readonly cbARLotPaymentAllocations = 'LOTPAYMENTALLOCATION.ASPX';
    static readonly cbARCollections = 'COLLECTIONS.ASPX';
    static readonly cbARAssessmentAndBillingRules = 'ASSESSMENT.ASPX';
    static readonly cbARAssessmentSummaryRules = 'ASSESSMENT_SUMMARY';
    static readonly cbARAssessmentEditRuleCode = 'EditRuleCode';
    static readonly cbARAssessmentRuleDetail = 'AssessmentRuleDetail';
    static readonly cbARAssessmentRuleConfigurationType = 'ConfigurationType';
    static readonly cbARAnnualDiscountSummaryRules = 'ANNUAL_DISCOUNT_SUMMARY';
    static readonly cbARAnnualDiscountRuleDetail = 'AnnualDiscountRuleDetail';
    static readonly cbARLateFeeSummaryRules = 'LATE_FEE_RULE_SUMMARY';
    static readonly cbARLateFeeRuleDetail = 'LateFeeRuleDetail';
    static readonly cbARClosingFeeSummaryRules = 'CLOSING_FEE_RULE_SUMMARY';
    static readonly cbARClosingFeeRuleDetail = 'ClosingFeeRuleDetail';
    static readonly cbARClosingFeeRulesAssessment = 'ClosingFeeRulesAssessment';
    static readonly cbARClosingFeeInitialAssessmentRules = 'CLOSING_FEE_INITIAL_ASSESSMENT';
    static readonly cbARFinanceChargeSummaryRules = 'FINANCE_CHARGE_SUMMARY';
    static readonly cbARFinanceChargeRuleDetail = 'FinanceChargeRuleDetail';
    static readonly cbARSpecialAssessmentSummaryRules = 'SPECIAL_ASSESSMENT_SUMMARY';
    static readonly cbARSpecialAssessmentRuleDetail = 'SpecialAssessmentRuleDetail';
    static readonly cbARBillingRules = 'BILLINGRULES.ASPX';
    static readonly cbARBillingRulesConfigType = 'ConfigurationType';
    static readonly cbARBillingRulesRuleName = 'EditRuleCode';
    static readonly cbARBillingRulesDetails = 'BillingRuleDetail';
    static readonly cbARBillingRulesRuleItems = 'BillingRuleItems';
    static readonly cbARBillingRuleItemEditor = 'BillingRuleItemEditor';
    static readonly cbARBillingLateFeeRules = 'BILLINGLATEFEERULES.ASPX';
    static readonly cbARBillingLateFeeRuleEditor = 'BillingLateFeeRuleEditor';
    static readonly cbARAgingSummary = 'ARAGINGSUMMARY.ASPX';
    static readonly cbARConveyanceAndDiscountRules = 'CONVEYANCEANDDISCOUNTRULES.ASPX';
    // Accounts Payable
    static readonly cbAPLedger = 'MP_CB_AP_LEDGER';
    static readonly cbAPBatches = 'CIRABOOK_BATCH.ASPX';
    static readonly cbAPSubmitInvoice = 'APPAYMENTREQUEST';
    static readonly cbAPSearchInvoices = 'INVOICESEARCH.ASPX';
    static readonly cbAPEftPaymentManagement = 'EFTPAYMENTMANAGEMENT.ASPX';
    static readonly cbAPCheckPritingManagement = 'CHECKPRINTINGMANAGEMENT.ASPX';
    static readonly cbAPVendorAging = 'CIRABOOKVENDORAGINGREPORT.ASPX';
    static readonly cbAPUnappliedPayments = 'APUNAPPLIEDPAYMENTS.ASPX';
    static readonly cbAPWFReimbursmentRequest = 'REIMBURSEMENTREQUEST.ASPX';
    static readonly cbAPWFVendorMissingBills = 'CIRABOOK_VENDORMISSINGBILLS.ASPX';
    static readonly cbAPWFManageVendorEdit = 'MANAGEWORKFLOWVENDOREDIT.ASPX';
    static readonly cbAPWFSubmittedInvoices = 'INVOICES.ASPX';
    static readonly cbAPVendorTenNinetyNine = 'CIRABOOK_VENDOR1099.ASPX';
    static readonly cbAPVendor1099IRSFileGenerator = 'VENDOR1099MANAGEMENT.ASPX';
    static readonly cbAPOpenAP = 'ACCOUNTSPAYABLE.ASPX';
    static readonly cbAPBillAnalysis = 'CIRABOOKS_APBILLANALYSIS.ASPX';
    static readonly cbAPExpenseDetail = 'EXPENSEDETAIL.ASPX';
    static readonly ccbAPBillsToPay = 'CIRABOOK_MANAGEMENTCOMPANY_SELECTBILLSTOPAY.ASPX';

    // General Ledger
    static readonly cbGLTrialBalance = 'MP_CB_GL_TRIAL_BALANCE';
    static readonly cbGLLedgerReport = 'MP_CB_GL_LEDGER_REPORT';
    static readonly cbGLJournalEntry = 'MP_CB_GL_JOURNAL_ENTRY';

    // Finance Report
    static readonly cbFRActualVsBudget = 'MP_CB_FR_ACTUAL_VS_BUDGET';
    static readonly cbFRFinancialSummary = 'FINANCIALSUMMARY.ASPX';
    static readonly cbFRBenchmarkReport = 'BENCHMARK.ASPX';

    // Entity Configuration
    static readonly cbEntityConfiguration = 'MP_CB_ENTITY_CONFIGURATION';
    static readonly cbEntityAuditLog = 'CIRABOOKS_LOGVIEWER.ASPX';

    // Configurations
    static readonly violationsConfiguration = 'CONFIGURATION.ASPX';
    static readonly violationsEscalationConfig = 'Configuration_NotificationConfiguration';
    static readonly violationsCatSubCatConfig = 'Configuration_ViolationCatSubCat';
    static readonly violationsReRestrictionDefConfig = 'Configuration_DeedRestrictionDefinition';
    static readonly notificationTemplates = 'Configuration_Templates';
    static readonly accCategoriesConfig = 'Configuration_AccCategories';
    static readonly paoConfiguration = 'Configuration_PaymentApplicationOrder';
    static readonly financialConfiguration = 'Configuration_FinancialPackageConfiguration';
    static readonly aapWfAutoActionConfig = 'Configuration_AAPWFAutoActionConfiguration';
    static readonly aapWfChecklistConfig = 'Configuration_AAPWFConfiguration';
    static readonly billingTypesConfig = 'Configuration_BillingTypes';
    static readonly aapCrossEntityBillConfiguration = 'Configuration_CrossEntityAPBillConfiguration';
    static readonly accountingConfiguration = 'Configuration_CommunityAccounting';
    static readonly enforcementConfiguration = 'Configuration_Enforcement';
    static readonly communityAutoCloseReportGenConfiguration = 'Configuration_COMMUNITY_AUTO_CLOSE_REPORT_GEN';
    static readonly processTrackerConfiguration = 'PROCESSTRACKER.ASPX';
    static readonly transitionTaskTemplatesConfiguration = 'Configuration_TransitionTaskTemplates';
    static readonly recommendationsAssumptionsConfiguration = 'Configuration_RecommendationsAssumptions';
    static readonly supplementalInformationConfiguration = 'Configuration_SupplementalInformation';
    static readonly transitionDocumentConfiguration = 'Configuration_TransitionDocument';
    static readonly egnyteConfiguration = 'Configuration_Egnyte';
    static readonly workOrderWorkAreaConfiguration = 'Configuration_WorkOrderWorkAreas';
    static readonly ciraHelpConfiguration = 'Configuration_Help';
    static readonly testPlanConfiguration = 'TESTPLANCONFIGURATION.ASPX';

    static readonly batchJobEmailsConfig = 'Configuration_WELCOME_LETTER_EMAIL';
    static readonly modulesConfiguration = 'Configuration_Modules';
    static readonly servicesConfiguration = 'Configuration_Services';
    static readonly processTrackerConfig = 'Configuration_ProcessTracker';
    static readonly reportTemplatesConfig = 'Configuration_ReportTemplates';
    static readonly letterTemplateConfig = 'Configuration_BUILDER_STATEMENT_COVER_LETTER';
    static readonly letterHeadTemplateConfig = 'Configuration_REPORT_PAGE_FOOTER';
    static readonly responseTemplatesConfig = 'Configuration_CustomResponseTemplates';
    static readonly boardPortalConfig = 'Configuration_BoardPortal';

    static readonly communityConfiguration = 'Configuration_CommunityConfiguration';
    static readonly collectionsConfiguration = 'Configuration_CollectionsConfiguration';
    static readonly businessHourConfig = 'MP_BUSINESS_HOUR_CONFIG';
    static readonly holidayConfig = 'MP_HOLIDAY_CONFIG';
    static readonly customerDefinedInfoConfig = 'EntityConfiguration';
    static readonly statementsConfig = 'MP_STATEMENTS_CONFIG';
    static readonly fulfillmentJobSpecialPricingConfiguration = 'Configuration_FJSPC';
    static readonly builderConfig = 'Configuration_BuilderConfiguration';
    static readonly notesConfig = 'Configuration_Notes';
    static readonly massCommunicationConfig = 'Configuration_MassCommunicationTemplateConfiguration';
    static readonly massCommunicationTemplateConfig = 'Configuration_TemplateConfig';
    static readonly printingProviderConfig = 'Configuration_PrintingProvider';
    static readonly amenityConfig = 'Configuration_Amenity';
    static readonly welcomeLetterConfig = ''; // TODO

    static readonly boardApprovalConfig = 'Configuration_BoardApproval';
    static readonly closingPortalConfig = 'closingPortal_Configuration.aspx';
    static readonly ciraConnectFee = 'Configuration_CiraConnectFee';
    static readonly infoConfig = 'Configuration_Info';
    static readonly brandingConfig = 'Configuration_BrandingConfiguration';
    static readonly feesAndChargesConfiguration = 'Configuration_ConveyanceFeeCharge';
    static readonly accountInquiryFulfillmentConfig = 'Configuration_AccountInquiryFulfillment';

    static readonly residentPortalConfig = 'Configuration_ResidentPortal';
    static readonly serviceRolesConfig = 'Configuration_ServiceRoles';
    static readonly serviceGroupsConfig = 'Configuration_ServiceGroups';
    static readonly calendarConfig = 'Configuration_AssociationCalendarLabelTypeConfiguration';

    static readonly caAccounting = 'CA_Accounting';
    // should be from Configuration.aspx, function helpContainer_Load
    static readonly miscInvoiceTypeConfig = 'Configuration_MiscInvoiceTypeConfigurations';

    // Tools Module
    static readonly toolsManageProperties = 'MP_TOOLS_MANAGE_PROPERTIES';
    static readonly toolsLogContact = 'MP_TOOLS_LOG_CONTACT';
    static readonly toolsACHImport = 'MP_TOOLS_OWNER_ACH_MIGRATION';
    static readonly toolsVendorImport = 'MP_TOOLS_VENDOR_MIGRATION';
    static readonly toolsLotLoadImport = 'MP_TOOLS_LOT_LOAD_IMPORT';
    static readonly toolsARLoad = 'MP_TOOLS_AR_LOAD';
    static readonly toolsUserDirectory = 'MP_USER_DIRECTORY';
    static readonly toolsPortalUserManagement = 'SECURE_USERMANAGER.ASPX';
    static readonly toolsUserSetup = 'USERSETUP.ASPX';
    static readonly automatedPrintDocument = 'PRINTING_DOWNLOADQUEUE.ASPX';
    static readonly toolsLocationManagement = 'LOCATION_MANAGEMENT';
    static readonly toolsLocationSatelliteOfficeManagement = 'LOCATION_SATELLITE_OFFICE_MANAGEMENT';
    static readonly toolsBankingPartnerLocationRemitToAddress = 'BANKING_PARTNER_LOCATION_REMIT_TO_ADDRESS';

    // Shared Services Module
    static readonly closingRequests = 'CLOSINGREQUESTS.ASPX';
    static readonly fulfillmentQueue = 'FULFILLMENTQUEUE.ASPX';
    static readonly architecturalApplications = 'ARCHITECTURALAPPLICATIONS.ASPX';
    static readonly soaCommunityBlocks = 'SOACOMMUNITYBLOCKS.ASPX';
    static readonly statementApprovalQueue = 'STATEMENTAPPROVALQUEUE.ASPX';
    static readonly orderAnnualCoupons = 'ORDERANNUALCOUPONS.ASPX';

    // Project Tasks
    static readonly projectTasks = 'PROJECTTASKS.ASPX';
    // Internal Tasks
    static readonly internalTasks = 'INTERNALTASKS.ASPX ';

    // Print Statement
    static readonly printStatement = 2382;

    // Management Report
    static readonly managementReport = ''; // TODO

    // Budget Rules
    static readonly budgetRules = ''; // TODO
    // Welcome Letter Queue
    static readonly letterQueue = 'welcome letter process';

    // My Portfolio Module
    static readonly portfolioCommunities = 'MY_COMMUNITIES';
    static readonly portfolioCommunitiesMap = 'MY_COMMUNITIES_MAP';
    static readonly transitionChecklist = 'TRANSITIONCHECKLIST.ASPX';
    static readonly accountManagement = 'ACCOUNTMANAGEMENT.ASPX';

    // On-Boarding Flags module
    static readonly modifyOnBoardingFlags = 'MODIFYINCOMINGASSOCIATION.ASPX';
    static readonly createOnBoardingTask = 659;
    static readonly createDocumentChecklist = 224;

    // User setup
    static readonly userSetupHelpId = 2185;

    // Board Approval key
    static readonly boardApproval = 'MP_BOARD_APPROVALS';

    // WorkOrder Key
    static readonly workorder = 'WORKORDERS.ASPX';

    // Revenue Management
    static readonly cbRMBillingItemManagement = 'BILLINGITEMQUANTITYMANAGEMENT.ASPX';
    static readonly cbRMBillingQueueManagement = 'BILLINGQUEUEMANAGEMENT.ASPX';
    static readonly cbRMMyCustomerCharges = 'MYCUSTOMERCHARGES.ASPX';
    static readonly cbRMCustomerContracts = 'CUSTOMERCONTRACTMANAGEMENT.ASPX';
    static readonly cbRMSubscriptionSetup = 'SUBSCRIPTIONSETUP.ASPX';
    static readonly cbRMCustomerCategorySetup = 'CUSTOMERCATEGORYSETUP.ASPX';
    static readonly ccbRMBillingItemCategory = 'BILLINGITEMCATEGORYSETUP.ASPX';
    static readonly cbRMProductCategorySetup = 'PRODUCTCATEGORYSETUP.aspx';
    static readonly ccbRMProductSetup = 'PRODUCTSETUP.ASPX';
    static readonly ccbTMChargeRateCategorySetup = 'CHARGERATECATEGORYSETUP.ASPX';
    static readonly ccbTMChargeRateSetup = 'CHARGERATESETUP.ASPX';
    static readonly ccbRMContractFormSetup = 'CONTRACTFORMSETUP.ASPX';
    static readonly ccbTEChargeRateCategoryCategory = 'CHARGERATESETUP.ASPX';
    static readonly ccbRmBillingRulesSetup = 'BillingRuleSetup.aspx';
    static readonly ccbTMChargeCodeCategorySetup = 'CHARGECODECATEGORYSETUP.ASPX';
    static readonly ccbTMChargeCodeSetup = 'CHARGECODESETUP.ASPX';

    // CCB General Ledger
    static readonly ccbGLReport = 'CIRABOOK_MANAGEMENTCOMPANY_GENERALLEDGERREPORT.ASPX';
    static readonly ccbGLOpenCloseBooks = 'CIRABOOK_MANAGEMENTCOMPANY_OPEN_CLOSE_BOOKS.ASPX';
    static readonly ccbGLBudgets = 'CIRABOOK_MANAGEMENTCOMPANY_CIRABUDGET.ASPX';
    static readonly ccbGLJournalEntries = 'CIRABOOK_MANAGEMENTCOMPANY_JOURNALENTRIES.ASPX';
    static readonly ccbGLJournalEntryTemplate = 'CIRABOOK_MANAGEMENTCOMPANY_JETEMPLATE.ASPX';
    static readonly ccbGLTrialBalance = 'CIRABOOK_MANAGEMENTCOMPANY_TRIALBALANCE.ASPX';

    // Entity
    static readonly ccbEntityAuditLog = 'CIRABOOK_MANAGEMENTCOMPANY_LOGVIEWER.ASPX';
    static readonly ccbEntityConfiguration = 'CIRABOOK_MANAGEMENTCOMPANY_CONFIGURATION.ASPX';
    static readonly ccbGLBaseAccountEditor = 'GLBaseAccountEditor';
    static readonly ccbGLAccountDimensionEditor = 'GLAccountDimensionEditor';
    static readonly ccbGLSubCategoryEditor = 'GLSubCategoryEditor';
    static readonly ccbGLSubAccountEditor = 'GLSubAccountEditor';
    static readonly ccbGLAccountGroupEditor = 'GLAccountGroupEditor';
    static readonly ccbGLAccountLabelEditor = 'GLAccountLabelEditor';
    static readonly ccbGLDimensionGroupEditor = 'GLDimensionGroupEditor';

    // Configuration
    static readonly ciramailTemplatesConfig = 'Configuration_CIRA_MAIL_TEMPLATES';

    // Property Conveyance key
    static readonly propertyConveyance = 'PROPERTYCONVEYANCEWORKQUEUE.ASPX';

    // Time and Expense key
    static readonly timeAndExpense = 'TIMEANDEXPENSEMANAGEMENT.ASPX';
    static readonly timeAndExpenseSubmissions = 'TIMEANDEXPENSESUBMISSIONS.ASPX';
    static readonly timeAndExpensePayrollReimbursement = 'TIMEANDEXPENSEPAYROLLREIMBURSEMENT.ASPX';

    // My Work Inbox
    static readonly myworkInbox = 'MYWORKINBOX.ASPX';

    // Resident Contact Logs
    static readonly residentContactLogs = 'CALLLOGS.ASPX';
    static readonly residentContactLogsDetail = 'CALLLOGSDETAIL.ASPX';

    // Common Lots
    static readonly commonLotsAppraisal = 'COMMONLOTAPPRAISAL.ASPX';
    static readonly commonLots = 'COMMONLOTSVIEW.ASPX';

    static readonly bankReturns = 'BANKRETURNS.ASPX';
    static readonly paymentPostErrors = 'PAYMENTPOSTERRORS.ASPX';

    // Violation Review - My Dashboard: Open Violations Requiring Review
    static readonly violationReview = 'VIOLATIONREVIEW.ASPX';
    static readonly violationReject = 'rejectviolation.aspx';
    static readonly detailedViolationLog = 'DETAILEDVIOLATIONSLOG.ASPX';
    static readonly allViolations = 'PropertyViolationsTab';
    static readonly openViolationsLog = 'Open Violations Log';
    static readonly openViolationsLogDetails = 'OPENVIOLATIONSLOGDETAIL.ASPX';
    static readonly violationsLastInspectionLog = 'LASTINSPECTIONRESULTS.ASPX';
    static readonly certifiedTracking = 'PRINTING_CERTIFIEDDETAILS.ASPX';
    static readonly violationsLastInspectionLogDetail = 'LASTINSPECTIONRESULTSDETAIL1.aspx';
    static readonly recordInitialViolation = 'RECORDVIOLATIONS.ASPX';
    static readonly inspectionScheduler = 'INSPECTIONSCHEDULER.ASPX';
    static readonly communityReportViolations = 'REPORTVIOLATION.ASPX';

    // Vendor Management
    static readonly vendorManagement = 'VENDORMANAGEMENT.ASPX';
    static readonly contract = 'CONTRACT.ASPX';

    // Process Tracker
    static readonly ptFrp = 411;
    static readonly ptMrg = 393;
    static readonly ptCo = 399;
    static readonly ptSg = 406;
    static readonly ptBp = 419;
    static readonly ptSt = 2370;
    static readonly ptFt = 2369;

    // Community Notes
    static readonly communityNotes = 'COMMUNITYNOTES.ASPX';

    // Community Assets
    static readonly communityAssets = 'ASSETSVIEW.ASPX';
    // My Calendar
    static readonly myCalendar = 'MYCALENDAR.ASPX';

    // Borad Committee Members
    static readonly boardCommiteeMembers = 'BOARDMEMBERS.ASPX';

    // Property Tax Appraisal
    static readonly propertyTaxAppraisal = 'PROPERTYTAXAPPRAISAL.ASPX';

    // Community Amenities and Access Control
    static readonly amenitiesAndAccessControl = 'COMMUNITYAMENITIES.ASPX';

    // Schedule Assessment
    static readonly scheduleFirstAssessmentId = 2175;
    static readonly initialAssessmentId = 2176;

    // Location Manager

    static readonly locationManager = 'CLOSINGPORTALLOCATIONMANAGER.ASPX';

    static readonly boardMemberCurrentOwner = 'STATUS_Current Owner';

    // Community Communication Logs
    static readonly communicationLogs = 'COMMUNICATIONS.ASPX';

    // Community Insurance
    static readonly insurance = 'INSURANCEVIEW.ASPX';

    // Community Announcement Logs
    static readonly announcementLogs = 'ASSOCIATION_ANNOUNCEMENTS_PAGE';

    // Community Achievements
    static readonly achievements = 'ACHIEVEMENTS.ASPX';

    // Email Composer
    static readonly emailComposer = 'EmailComposer.aspx';

    // Community Mail Merge
    static readonly mailMerge = 'MAILMERGE.ASPX';

    // Corporate AR Invoice Analysis
    static readonly ccbARInvoiceAnalysis = 'CIRABOOK_MANAGEMENTCOMPANY_ARINVOICEANALYSIS.ASPX';

    // Corporate Accounts Payable
    static readonly ccbAPLedger = 'CIRABOOK_MANAGEMENTCOMPANY_VENDORAPLEDGER.ASPX';
    static readonly ciraMailSignatureTool = 'Email_Signature';
    static readonly ccbAPBillAnalysis = 'CIRABOOK_MANAGEMENTCOMPANY_APBILLANALYSIS.ASPX';
    static readonly ccbVendorAging = 'CIRABOOK_MANAGEMENTCOMPANY_VENDORAGINGREPORT.ASPX';
    static readonly ciraMailBoxManagerTool = 'Mailbox_Manager';
    static readonly ccbApVendorManagement = 'CIRABOOK_MANAGEMENTCOMPANY_VENDORMANAGEMENT.ASPX';
    static readonly ccbApCheckPrintingManagement = 'CIRABOOK_MANAGEMENTCOMPANY_CHECKPRINTINGMANAGEMENT.ASPX';
    static readonly ccbEftPaymentManagement = 'CIRABOOK_MANAGEMENTCOMPANY_EFTPAYMENTMANAGEMENT.ASPX';

    // My Text
    static readonly myText = 'CiraText.aspx';
    static readonly ccbVendor1099 = 'CIRABOOK_MANAGEMENTCOMPANY_VENDOR1099.ASPX';
    static readonly ccbWorkQueueManagement = 'CIRABOOK_MANAGEMENTCOMPANY_WORKQUEUE.ASPX';

    // Accounts Receivable
    static readonly ccbARLedger = 'CIRABOOK_MANAGEMENTCOMPANY_ARLEDGER.ASPX';
    static readonly ccbArCustomerAging = 'CIRABOOK_MANAGEMENTCOMPANY_CUSTOMERAGINGREPORT.ASPX';

    // Cash Management
    static readonly ccbCMDeposits = 'CIRABOOK_MANAGEMENTCOMPANY_DEPOSITS.ASPX';

    static readonly ccbCMBankAccounts = 'CiraBooksConfiguration_BankAccounts';

    // Corporate Batches
    static readonly ccbBatches = 'CIRABOOK_MANAGEMENTCOMPANY_BATCH.ASPX';

    // CCB_CM
    static readonly ccbCMBankReconciliation = 'CIRABOOKSBANKRECONCILE.ASPX';

    // CCB-Reports
    static readonly ccbReports = 'CIRABOOK_MANAGEMENTCOMPANY_REPORTS.ASPX';

    // Corporate Cash Management
    static readonly ccbCMCashReceipts = 'CIRABOOK_MANAGEMENTCOMPANY_CASHRECEIPTS.ASPX';

    // CCB-AR-Customer-Management
    static readonly ccbArCustomerManagement = 'COMPANY_CUSTOMERMANAGEMENT.ASPX';

    // Testing Configuration
    static readonly testingConfiguration = 'TESTINGCONFIGURATION.ASPX';

    static readonly propertyAssessmentAndBillingRules = 'PropertyOwner.aspx';
}
